import React, { useContext, useLayoutEffect } from 'react';
import Page from '../../layout/Page';
import { useParams } from 'react-router-dom';
import { QuestRoute } from '../../api/QuestRoutes';
import Loading from '../../Loading';
import PageBreak from '../../layout/PageBreak';
import Wallet from './Wallet';
import Purchases from './Purchases';
import Management from './Management';
import CCInfo from './CCInfo';
import Invoices from '../reporting/sales/Invoices';
import Audit from './Audit';
import WashClubManagement from './WashClubManagement';
import WashClubTransactions from './WashClubTransactions';
import ClaimedDeals from './ClaimedDeals';
import RoleProtected, { userRoles } from '../../RoleProtected';
import Button from '../../forms/Button';
import { UserContexts } from '../../stateProvider/UsersContext';
import ModalFactory from '../../Modal';
import UserNotes from '../../processors/UserNote';
import Card from '../../forms/Card';

export const accountTypes = {
    parent: 'Parent',
    child: 'Child',
    standard: 'Standard',
}

const User = ({ ...props }) => {

    const context = useContext(UserContexts);

    const { guid } = useParams();

    useLayoutEffect(() => {
        if (guid === context.userGuid) return;
        context.setGuid(guid)
    }, [guid]);

    if (!context.user) return <Loading page />;

    const { user } = context

    const { parent, child, standard } = accountTypes;

    return (
        <RoleProtected roles={userRoles.viewCustomers}>
            <Page
                tabTitle={user.fullName}
                title={user.fullName + (user.accountType !== standard ? user.accountType === parent ? ' (Parent)' : ' (Child)' : '')}
                icon={user.accountType !== standard ? 'family' : ''}
                controls={[
                    (user.accountType === child && user.parent) ? <Button customerId={user.parent.customerId}>To Parent</Button> : null,
                ]}
                HSpage='user_page'
                tabs
            >
                <Management tab='User' />

                <Card tab='Notes'>
                    <UserNotes customerId={user.customerId} />
                </Card>

                <WashClubManagement tab='Wash Club' />

                <PageBreak tab='Financial'>
                    <CCInfo />
                    <Wallet />
                    <Purchases />
                </PageBreak>

                <Audit tab='Audit' />

                <Invoices
                    tab='Invoices'
                    endpoint={QuestRoute.users + '/' + guid + '/invoices'}
                    justReport
                    roles={userRoles.viewAuditReports}
                />

                <WashClubTransactions tab='Wash Club Transactions' />

                <ClaimedDeals tab='Claimed Deals' />

            </Page>
        </RoleProtected>
    );
}

export default User;